export default __webpack_public_path__ + "static/media/ava-04.7e6a1147.png";